var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"burger",class:_vm.getClasses,attrs:{"aria-label":"Открыть меню"},on:{"click":function($event){return _vm.$emit('toggle-sidebar')}}},[_c('span'),_c('span'),_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }